export default __webpack_public_path__ + "42a577f1a276c103ca4a4e26fbaebcf0.png";